module.exports = __webpack_public_path__ + "static/media/coinmarketcap.4034d535.png";